
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"78","viewBox":"0 0 53 78","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.81 2.821L48.435.957a4 4 0 014.229 3.993v59.455a4 4 0 01-4 4H4.635a4 4 0 01-3.988-4.306L4.53 13.501 15.81 2.821z","fill":"#ECEFF1"}}),_c('path',{attrs:{"d":"M42.233 49.983a1 1 0 011.192.48l1.336 2.5a1 1 0 00.46.435l2.622 1.22a1 1 0 01.527 1.223l-.826 2.47a1 1 0 00.019.687l.983 2.471a1 1 0 01-.515 1.28l-2.42 1.101a1 1 0 00-.49.483l-1.116 2.353a1 1 0 01-1.227.518l-2.736-.937a1 1 0 00-.633-.005l-2.696.878a1 1 0 01-1.192-.48l-1.336-2.5a1 1 0 00-.46-.435l-2.622-1.22a1 1 0 01-.527-1.224l.826-2.47a1 1 0 00-.02-.686l-.983-2.471a1 1 0 01.516-1.28l2.42-1.102a1 1 0 00.49-.482l1.115-2.353a1 1 0 011.228-.518l2.735.937a1 1 0 00.634.005l2.696-.878zM34.664 68.389h9.078v9.577l-4.948-3.041-4.13 3.04V68.39z","fill":"#31A2F0"}}),_c('rect',{attrs:{"x":"11.428","y":"22.399","width":"32.978","height":"3.927","rx":"1.252","fill":"#113751"}}),_c('rect',{attrs:{"x":"11.428","y":"31.543","width":"32.978","height":"3.927","rx":"1.252","fill":"#113751"}}),_c('rect',{attrs:{"x":"11.428","y":"40.687","width":"32.978","height":"3.927","rx":"1.252","fill":"#113751"}})])
          )
        }
      }
    